export default __webpack_public_path__ + "static/media/portfolio.5099db5b.png";